import type { CSSProperties } from 'react';

import classNames from 'classnames';

import SimpleModal from '@/ui/SimpleModal';

import { ButtonElement } from '../shared/buttonElement/ButtonElement';
import { TierCardElement } from '../shared/tierCardElement/TierCardElement';
import { changePlanModalContent } from './ChangePlanModalElement.css';
import type { ChangePlanModalElementProps } from './ChangePlanModalElement.types';

export function ChangePlanModalElement({
  element,
  isLoading,
  isOpen,
  onOpenChange,
  onCancel,
  translations,
  message,
  onSelectPrice,
}: ChangePlanModalElementProps) {
  const generatedStyle = {
    '--overlay-background-color': '#00000030',
    '--modal-close-button-color': undefined,
    '--modal-close-button-placement-top': '24px',
    '--modal-close-button-placement-right': '24px',
  } as CSSProperties;

  const { tier, subscribedToPriceIds } = element?.attrs?.data || { subscribedToPriceIds: [] };

  return (
    <SimpleModal
      isOpen={isOpen}
      onClose={!isLoading ? onOpenChange : undefined}
      className="shadow-lg sm:rounded-md overflow-hidden"
      style={generatedStyle}
      showCloseButton={false}
      showRoundedBorders={false}
      shouldCloseOnOutsideClick={false}
    >
      <div className={classNames(changePlanModalContent, 'w-full sm:min-w-[460px]')}>
        <h2 className="text-lg font-bold text-gray-900 text-center">{translations?.['billing.plan.change_plan']}</h2>
        {message && <p className="text-sm text-gray-400">{message}</p>}
        {tier && (
          <div className="flex gap-x-2 mt-4 overflow-y-scroll">
            <TierCardElement
              key={tier.id}
              tier={tier}
              subscribedToPriceIds={subscribedToPriceIds}
              disableActions={isLoading}
              translations={translations}
              onSelectPrice={onSelectPrice}
            />
          </div>
        )}
        <div className="flex justify-center w-full py-2">
          <ButtonElement variant="flush" onClick={onCancel} className="w-full">
            {translations?.['shared.cta.cancel']}
          </ButtonElement>
        </div>
      </div>
    </SimpleModal>
  );
}
